interface Props {
  searchTerm: string;
  setSearch: (v: string) => void;
  fileTypeFilter: string;
  setTypeFilter: (v: string) => void;
  sortBy: 'date' | 'name' | 'size';
  setSortBy: (v: 'date' | 'name' | 'size') => void;
  clearFilters: () => void;
}

export function FileFilters({
  searchTerm,
  setSearch,
  fileTypeFilter,
  setTypeFilter,
  sortBy,
  setSortBy,
  clearFilters,
}: Props) {
  return (
    <div className="bg-white rounded-lg shadow-md p-3 md:p-6">
      <div className="flex flex-col gap-2 md:flex-row md:gap-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="Search by filename..."
            value={searchTerm}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-3 py-2 bg-white border border-steel/30 rounded-md placeholder-steel/50 text-navy text-sm focus:outline-none focus:ring-2 focus:ring-orca-elevate focus:border-orca-elevate"
          />
        </div>

        <div className="flex gap-2 md:contents">
          <select
            value={fileTypeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="flex-1 md:w-48 px-3 py-2 bg-white border border-steel/30 rounded-md text-navy text-sm focus:outline-none focus:ring-2 focus:ring-orca-elevate focus:border-orca-elevate"
          >
            <option value="all">All Types</option>
            <option value="audio">Audio</option>
            <option value="text">Text</option>
            <option value="transcript">Transcript</option>
            <option value="document">Document</option>
          </select>

          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value as 'date' | 'name' | 'size')}
            className="flex-1 md:w-48 px-3 py-2 bg-white border border-steel/30 rounded-md text-navy text-sm focus:outline-none focus:ring-2 focus:ring-orca-elevate focus:border-orca-elevate"
          >
            <option value="date">Date</option>
            <option value="name">Name</option>
            <option value="size">Size</option>
          </select>
        </div>
      </div>

      {(searchTerm || fileTypeFilter !== 'all') && (
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-steel">
          {searchTerm && (
            <span className="px-2 py-0.5 bg-orca-elevate/10 text-orca-elevate rounded-md">
              "{searchTerm}"
            </span>
          )}
          {fileTypeFilter !== 'all' && (
            <span className="px-2 py-0.5 bg-orca-elevate/10 text-orca-elevate rounded-md">
              {fileTypeFilter}
            </span>
          )}
          <button onClick={clearFilters} className="text-red-600 hover:text-red-700 font-medium">
            Clear
          </button>
        </div>
      )}
    </div>
  );
}
